if (!window.vkCategorySizeGuideInitialized) {
  window.vkCategorySizeGuideInitialized = true;

  const closeCustomSelect = (customSelect) => {
    const trigger = customSelect?.querySelector('[data-vk-category-size-guide-custom-trigger]');
    const options = customSelect?.querySelector('[data-vk-category-size-guide-custom-options]');
    if (!trigger || !options) return;

    options.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  };

  const closeAllCustomSelects = (except = null) => {
    document.querySelectorAll('[data-vk-category-size-guide-custom-select]').forEach((customSelect) => {
      if (customSelect !== except) closeCustomSelect(customSelect);
    });
  };

  const openCustomSelect = (customSelect) => {
    const trigger = customSelect?.querySelector('[data-vk-category-size-guide-custom-trigger]');
    const options = customSelect?.querySelector('[data-vk-category-size-guide-custom-options]');
    if (!trigger || !options) return;

    closeAllCustomSelects(customSelect);
    options.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  };

  const setActiveCategory = (guide, categoryKey) => {
    guide.querySelectorAll('[data-vk-category-size-guide-tab]').forEach((tab) => {
      const isActive = tab.dataset.vkCategorySizeGuideTab === categoryKey;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    guide.querySelectorAll('[data-vk-category-size-guide-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.vkCategorySizeGuidePanel !== categoryKey;
    });

    const select = guide.querySelector('[data-vk-category-size-guide-select]');
    if (select) select.value = categoryKey;

    const customSelect = guide.querySelector('[data-vk-category-size-guide-custom-select]');
    if (customSelect) {
      const selectedOption = customSelect.querySelector(`[data-vk-category-size-guide-custom-option="${categoryKey}"]`);
      const label = customSelect.querySelector('[data-vk-category-size-guide-custom-label]');
      customSelect.querySelectorAll('[data-vk-category-size-guide-custom-option]').forEach((option) => {
        const isActive = option.dataset.vkCategorySizeGuideCustomOption === categoryKey;
        option.classList.toggle('is-active', isActive);
        option.setAttribute('aria-selected', String(isActive));
      });
      if (selectedOption && label) label.textContent = selectedOption.textContent.trim();
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const customTrigger = target?.closest('[data-vk-category-size-guide-custom-trigger]');
    if (customTrigger) {
      const customSelect = customTrigger.closest('[data-vk-category-size-guide-custom-select]');
      const options = customSelect?.querySelector('[data-vk-category-size-guide-custom-options]');
      if (!customSelect || !options) return;

      if (options.hidden) {
        openCustomSelect(customSelect);
      } else {
        closeCustomSelect(customSelect);
      }
      return;
    }

    const customOption = target?.closest('[data-vk-category-size-guide-custom-option]');
    if (customOption) {
      const guide = customOption.closest('[data-vk-category-size-guide]');
      const customSelect = customOption.closest('[data-vk-category-size-guide-custom-select]');
      if (!guide || !customSelect) return;

      setActiveCategory(guide, customOption.dataset.vkCategorySizeGuideCustomOption);
      closeCustomSelect(customSelect);
      customSelect.querySelector('[data-vk-category-size-guide-custom-trigger]')?.focus({ preventScroll: true });
      return;
    }

    const tab = target?.closest('[data-vk-category-size-guide-tab]');
    if (tab) {
      const guide = tab.closest('[data-vk-category-size-guide]');
      if (!guide) return;

      setActiveCategory(guide, tab.dataset.vkCategorySizeGuideTab);
      tab.focus({ preventScroll: true });
      return;
    }

    closeAllCustomSelects();
  });

  document.addEventListener('change', (event) => {
    const select = event.target instanceof HTMLSelectElement ? event.target : null;
    if (!select?.matches('[data-vk-category-size-guide-select]')) return;

    const guide = select.closest('[data-vk-category-size-guide]');
    if (guide) setActiveCategory(guide, select.value);
  });

  document.addEventListener('keydown', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const customTrigger = target?.closest('[data-vk-category-size-guide-custom-trigger]');
    if (customTrigger) {
      const customSelect = customTrigger.closest('[data-vk-category-size-guide-custom-select]');
      const optionsContainer = customSelect?.querySelector('[data-vk-category-size-guide-custom-options]');
      const options = Array.from(customSelect?.querySelectorAll('[data-vk-category-size-guide-custom-option]') || []);
      if (!customSelect || !optionsContainer || !options.length) return;

      if (event.key === 'Escape') {
        closeCustomSelect(customSelect);
        return;
      }

      if (!['ArrowDown', 'ArrowUp', 'Enter', ' '].includes(event.key)) return;
      event.preventDefault();
      openCustomSelect(customSelect);
      const selectedIndex = options.findIndex((option) => option.getAttribute('aria-selected') === 'true');
      const nextIndex = event.key === 'ArrowUp' ? Math.max(0, selectedIndex - 1) : Math.max(0, selectedIndex);
      options[nextIndex].focus({ preventScroll: true });
      return;
    }

    const customOption = target?.closest('[data-vk-category-size-guide-custom-option]');
    if (customOption) {
      const customSelect = customOption.closest('[data-vk-category-size-guide-custom-select]');
      const options = Array.from(customSelect?.querySelectorAll('[data-vk-category-size-guide-custom-option]') || []);
      const currentIndex = options.indexOf(customOption);
      if (!customSelect || currentIndex < 0) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeCustomSelect(customSelect);
        customSelect.querySelector('[data-vk-category-size-guide-custom-trigger]')?.focus({ preventScroll: true });
        return;
      }

      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        customOption.click();
        return;
      }

      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let nextIndex = currentIndex;
      if (event.key === 'ArrowDown') nextIndex = Math.min(options.length - 1, currentIndex + 1);
      if (event.key === 'ArrowUp') nextIndex = Math.max(0, currentIndex - 1);
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = options.length - 1;
      options[nextIndex].focus({ preventScroll: true });
      return;
    }

    const tab = target?.closest('[data-vk-category-size-guide-tab]');
    if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    const guide = tab.closest('[data-vk-category-size-guide]');
    if (!guide) return;

    const tabs = Array.from(guide.querySelectorAll('[data-vk-category-size-guide-tab]'));
    const currentIndex = tabs.indexOf(tab);
    if (currentIndex < 0) return;

    let nextIndex = currentIndex;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    event.preventDefault();
    const nextTab = tabs[nextIndex];
    setActiveCategory(guide, nextTab.dataset.vkCategorySizeGuideTab);
    nextTab.focus({ preventScroll: true });
  });
}
